import { useAnimationLoop } from "../useAnimationLoop"

export enum EOscillationType {
  SIN = 'SIN',
  COS = 'COS',
  MOD = 'MOD'
}

export type UseOscillationProps = {
  speed?: number;
  type?: EOscillationType;
}

export type UseOscillation = {
  start: () => void;
  stop: () => void;
  oscillated: Ref<number>;
  normalized: ComputedRef<number>;
}

type Oscillator = {
  start: () => () => void;
  normalize: (x: number) => number;
}

export const useOscillation = (props: UseOscillationProps = {}): UseOscillation => {
  const speed = props.speed ?? 1.0;
  const oscType: EOscillationType = props.type || EOscillationType.SIN;

  const oscillated = ref<number>(0);
  let x: number = 0;
  
  const animation = useAnimationLoop({
    cancelPreviousOnStart: true
  });

  const oscillators: Record<EOscillationType, Oscillator> = {
    [EOscillationType.SIN]: {
      start: () => () => animation.start((ctx) => {
        oscillated.value = Math.sin(x);
        x += ctx.delta * speed;
        x = x % (Math.PI*2.0); 
      }),
      normalize: (x) => 0.5+0.5*x
    },
    [EOscillationType.COS]: {
      start: () => () => animation.start((ctx) => {
        oscillated.value = Math.cos(x);
        x += ctx.delta * speed;
        x = x % (Math.PI*2.0); 
      }),
      normalize: (x) => 0.5+0.5*x
    },
    [EOscillationType.MOD]: {
      start: () => {
        return () => {
          animation.start((ctx) => {
            oscillated.value = x;
            x += ctx.delta * speed;
            x = x % (Math.PI*2.0); 
          })
        } 
      },
      normalize: (x) => x / (Math.PI*2.0) 
    },
  }

  const start = () => {
    const o = oscillators[oscType].start();
    o();
  }

  const stop = () => {
    animation.stop();
  }

  const normalized = computed(() => oscillators[oscType].normalize(oscillated.value));

  return {
    start,
    stop,
    oscillated,
    normalized
  }
}
